import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function RouteAddIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="RouteAddIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"}} xmlSpace="preserve">
      <path
        fill="#FFFFFF"
        d="M85,35.2c-1.9-4.5-4.7-8.6-8.1-12.1c-3.5-3.5-7.5-6.2-12.1-8.1c-4.7-2-9.7-3-14.8-3s-10.1,1-14.8,3c-4.5,1.9-8.6,4.7-12.1,8.1c-3.5,3.5-6.2,7.5-8.1,12.1c-2,4.7-3,9.7-3,14.8s1,10.1,3,14.8c1.9,4.5,4.7,8.6,8.1,12.1c3.5,3.5,7.5,6.2,12.1,8.1c4.7,2,9.7,3,14.8,3s10.1-1,14.8-3c4.5-1.9,8.6-4.7,12.1-8.1c3.5-3.5,6.2-7.5,8.1-12.1c2-4.7,3-9.7,3-14.8S87,39.9,85,35.2z"/>
      <circle
        fill="#005a96"
        fillRule="evenodd"
        clipRule="evenodd"
        cx="50" cy="50" r="34.2" />
      <circle
        fill="#005a96"
        fillRule="evenodd"
        clipRule="evenodd"
        cx="50" cy="50" r="34.2" />
      <polygon
        fill="#FFFFFF"
        fillRule="evenodd"
        clipRule="evenodd"
        points="67.2,46.2 53.7,46.2 53.7,32.7 46.3,32.7 46.3,46.2 32.8,46.2 32.8,53.6 46.3,53.6 46.3,67.1 53.7,67.1 53.7,53.6 67.2,53.6 "/>
    </svg>
  </SvgIcon>
}

export default RouteAddIcon;
